import cn from 'bem-cn';

import { SwitchProps } from './Switch.types';
import './Switch.scss';

const b = cn('switch');

export const Switch = <T extends string | number = string>({
    options,
    value,
    onChange,
    className: mix,
}: SwitchProps<T>) => {
    function handleOptionClick(optionValue: T) {
        return () => {
            if (optionValue !== value) {
                onChange(optionValue);
            }
        };
    }

    return (
        <div className={b.mix(mix)}>
            {options.map(option => (
                <button
                    key={String(option.value)}
                    className={b('option', { active: option.value === value })}
                    onClick={handleOptionClick(option.value)}
                    type="button"
                >
                    {option.label}
                </button>
            ))}
        </div>
    );
};
